jQuery(document).ready(function($){

    // Assign handlers immediately after making the request,
    // and remember the jqxhr object for this request
    let $postalCode;
    let $houseNumber;

    $('.sac-postal, .sac-number').change(function(){
        let $field = $(this);
        let $el = $(this).find('input');
        let $form = $el.closest('form');

        if ($field.hasClass('sac-postal')) {
            $postalCode = $el.val().replace(" ", "");
        }

        if ($field.hasClass('sac-number')) {
            $houseNumber = $el.val().replace(" ", "");
        }

        if ($field.hasClass('sac-number')) {
            let data = {
                'action':  'postcode_complete_v2',
                'postalcode': $postalCode,
                'housenumber': $houseNumber
            };

            $form.addClass('sac-loading');

            $.post('/wp-admin/admin-ajax.php', data)
                .done(function (response) {
                    let parsedResponse = JSON.parse(response);
                    console.log(parsedResponse);
                    if (!parsedResponse['error']) {

                        $('.sac-street input').val(parsedResponse['street']);
                        $('.sac-city input').val(parsedResponse['city']);

                        // Add check
                        if (parsedResponse['street'] && parsedResponse['city']) {
                            $('.sac-street input').parent().addClass('checked-green non-editable');
                            $('.sac-city input').parent().addClass('checked-green non-editable');
                            // Enable readonly
                            $('.sac-street input').attr('readonly', true);
                            $('.sac-city input').attr('readonly', true);
                        }

                    } else {
                        // Make sure inputs are not checked if there is no response
                        $('.sac-street input').parent().removeClass('checked-green non-editable');
                        $('.sac-city input').parent().removeClass('checked-green non-editable');
                        // Disable readonly
                        $('.sac-street input').attr('readonly', false);
                        $('.sac-city input').attr('readonly', false);
                    }
                })
                .always(function () {
                    $form.removeClass('sac-loading');
                    $('.sac-street, .sac-city').removeClass('sac-hidden');
                });
        }
    });
});